import Vue from "vue";
import VueMatomo from "vue-matomo";
import "./plugins/axios"
import App from "./App.vue"
import router from "./router";
import store from "./store";
import config from "./config";

import i18n from "@/modules/i18n";
import CoreLdeVue from "@lde/core_lde_vue";
import matomoConfig, { matomoLogClickDirective, handleMatomoBlocked } from "@/modules/matomo";

Vue.use(CoreLdeVue);

Vue.use(VueMatomo, matomoConfig);
if (!Vue.prototype.$matomo) {
  handleMatomoBlocked(Vue);
}

Vue.directive("matomo-log-click", matomoLogClickDirective);

// Force production mode (Disable debugging in prod)
if (config.isProd) Vue.config.devtools = false;

export default new Vue({
    // eslint-disable-next-line
    name: "Main",
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");